<ng-container *transloco="let t" class="container">
  <app-admin-modal-layout
          [title]="title ?? ''"
          [saveLabel]="confirmButtonTitle ?? t('app.common.confirm')"
          [cancelLabel]="dismissButtonTitle ?? t('app.common.cancel')"
          (onSave)="onConfirmClick()"
          (onClose)="onDismissClick()"
          [showSave]="showConfirmButton"
  >
    @if (text) {
    <p class="pb-3">{{ text }}</p>
    }
    <div class="modal-scroll">
      <div [infiniteScrollDistance]="4" class="table table-last-row-no-border" infinite-scroll>
        <validator-result-message [validatorResult]="validatorResult" [keyPrefix]="keyPrefix"></validator-result-message>
      </div>
    </div>

    @if (confirmationText) {
    <p class="py-3 fw-bold">{{ confirmationText }}</p>
    }
  </app-admin-modal-layout>
</ng-container>



